import { format, parseISO } from "date-fns";

const COUNTRY_COLORS = {
  Pakistan: "#496E2D",
  Peru: "#D80027",
  "Costa Rica": "#0052B4",
};

const DEFAULT_COLOR = "#6366F1";
const ALL_COUNTRIES_COLOR = "#9CA3AF";

export const getCountryColor = (country) => COUNTRY_COLORS[country] || DEFAULT_COLOR;

const getDayNumber = (holiday) => {
  if (!holiday) return null;
  const parsed = Number(holiday.dayNumber);
  return Number.isNaN(parsed) ? null : parsed;
};

export const getHolidayActualDate = (holiday) => {
  if (!holiday?.startDate) return null;

  const baseDate = parseISO(holiday.startDate);
  if (Number.isNaN(baseDate.getTime())) {
    return null;
  }

  const dayNumber = getDayNumber(holiday);
  if (dayNumber && dayNumber > 1) {
    const actualDate = new Date(baseDate);
    actualDate.setDate(actualDate.getDate() + (dayNumber - 1));
    return actualDate;
  }

  return baseDate;
};

export const getNextUpcomingDateKey = (holidays = [], today = new Date()) => {
  if (!Array.isArray(holidays) || holidays.length === 0) {
    return null;
  }

  const referenceDate = new Date(today);
  referenceDate.setHours(0, 0, 0, 0);

  const upcomingEntry = holidays
    .map((holiday) => {
      const actualDate = getHolidayActualDate(holiday);
      return actualDate ? { date: actualDate } : null;
    })
    .filter(Boolean)
    .filter(({ date }) => date >= referenceDate)
    .sort((a, b) => a.date.getTime() - b.date.getTime())[0];

  return upcomingEntry ? format(upcomingEntry.date, "yyyy-MM-dd") : null;
};

export const groupHolidaysByMonth = (holidays) => {
  if (!holidays?.data) return {};

  const grouped = {};

  holidays.data.forEach((holiday) => {
    const date = parseISO(holiday.startDate);
    const monthYear = format(date, "MMMM, yyyy");

    if (!grouped[monthYear]) {
      grouped[monthYear] = [];
    }
    grouped[monthYear].push(holiday);
  });

  return grouped;
};

export const groupHolidaysByDate = (holidays) => {
  const groupedByDate = {};

  holidays.forEach((holiday) => {
    let dateKey;
    if (holiday.dayNumber && holiday.dayNumber > 1) {
      const baseDate = parseISO(holiday.startDate);
      const actualDate = new Date(baseDate);
      actualDate.setDate(actualDate.getDate() + (holiday.dayNumber - 1));
      dateKey = format(actualDate, "yyyy-MM-dd");
    } else {
      dateKey = holiday.startDate;
    }

    const uniqueKey = `${dateKey}-${holiday.name}-${holiday.region}-${holiday.dayNumber || 1}`;

    if (!groupedByDate[uniqueKey]) {
      groupedByDate[uniqueKey] = [];
    }
    const isDuplicate = groupedByDate[uniqueKey].some(
      (h) => h.id === holiday.id && h.dayNumber === holiday.dayNumber && h.region === holiday.region
    );
    if (!isDuplicate) {
      groupedByDate[uniqueKey].push(holiday);
    }
  });

  return Object.values(groupedByDate);
};

export const getCountryOptions = (allHolidays) => {
  const countryOptions =
    allHolidays?.countryList?.map((country) => ({
      value: country,
      label: country,
      color: getCountryColor(country),
    })) || [];

  return [{ value: "All", label: "All", color: ALL_COUNTRIES_COLOR }, ...countryOptions];
};
